import { Chip } from '@/shared/ui/chip'
import { Icon } from '@/shared/ui/icon'

// Метка «задачу видит заказчик» — в списке, на канбане и в шапке карточки:
// открытость наружу компании должна читаться без открытия задачи, она дороже
// любого другого её атрибута.
export function CustomerVisibleBadge({ className }: { className?: string }) {
  return (
    <Chip
      tone="info"
      title="Клиент компании видит эту задачу"
      {...(className ? { className } : {})}
    >
      <Icon name="eye" size={12} />
      Видно клиенту
    </Chip>
  )
}

// Компактный вариант для плитки канбана: там метрики идут иконками в мета-строке,
// и чип на всю ширину ломал бы ряд.
export function CustomerVisibleMark({ className }: { className?: string }) {
  return (
    <span
      role="img"
      aria-label="Видно клиенту"
      title="Клиент компании видит эту задачу"
      className={className ?? 'inline-flex text-info'}
    >
      <Icon name="eye" size={13} />
    </span>
  )
}
